import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import LeagueInfoWidget from '../League/Widgets/LeagueInfo';

const MPPDashboard = () => (
  <div id="league-MPP">
    <header className="content-header">
      <h1>
        Support
        <small>MPP</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-trophy" /> MPP
        </li>
        <li className="text-bold">
          <Link to="/mpp">Dashboard</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-12">
          <LeagueInfoWidget />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPDashboard);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Dashboard/index.js